/** Modos de visualizações dos clientes nas campanhas */
export interface CampanhaClienteVisualizacaoModo {
    id: number;
    nome: string;
    iconClass?: string;
}

export const campanhaClienteVisualizacaoModoOrigens: CampanhaClienteVisualizacaoModo = {
    id: 1,
    nome: 'Cadastrados'
};
export const campanhaClienteVisualizacaoModoAquisicoes: CampanhaClienteVisualizacaoModo = {
    id: 2,
    nome: 'Adquiridos'
};
export const campanhaClienteVisualizacaoModoAmbos: CampanhaClienteVisualizacaoModo = {
    id: 3,
    nome: 'Ambos'
};

export const campanhaClienteVisualizacaoModos: CampanhaClienteVisualizacaoModo[] = [
    campanhaClienteVisualizacaoModoOrigens,
    campanhaClienteVisualizacaoModoAquisicoes,
    campanhaClienteVisualizacaoModoAmbos
];

/** Verifica se o modo de visualização das campanhas dos cliente é pelas origens */
export function isCampanhaClienteVisualizacaoModoOrigens(modo: number): boolean {
    return modo === campanhaClienteVisualizacaoModoOrigens.id;
}

/** Verifica se o modo de visualização das campanhas dos cliente é pelas aquisições */
export function isCampanhaClienteVisualizacaoModoAquisicoes(modo: number): boolean {
    return modo === campanhaClienteVisualizacaoModoAquisicoes.id;
}

/** Verifica se o modo de visualização das campanhas dos cliente é ambos */
export function isCampanhaClienteVisualizacaoModoAmbos(modo: number): boolean {
    return modo === campanhaClienteVisualizacaoModoAmbos.id;
}
